export default {
  home: 'Home',
  menu: 'Menu',
  orders: 'Ordini',
};
